import * as React from 'react'

import location from '@/public/assets/icons/location.svg'
import location_white from '@/public/assets/icons/location_white.svg'
import credits_circle from '@/public/assets/icons/credits_circle.svg'
import arrow_next_gallery_slide_desktop from '@/public/assets/icons/arrow_next_gallery_slide_desktop.svg'
import arrow_prev_gallery_slide_desktop from '@/public/assets/icons/arrow_prev_gallery_slide_desktop.svg'
import blue_arrow_gallery_slide_mobile from '@/public/assets/icons/blue_arrow_gallery_slide_mobile.svg'
import arrow_blue_previous from '@/public/assets/icons/arrow_blue_previous.svg'
import car_listed from '@/public/assets/icons/car_listed.svg'
import arrow_white from '@/public/assets/icons/arrow_white.svg'

export interface IconProps {
    icon: string
    height?: string
    width?: string
}

class Icon extends React.Component<IconProps, {}> {
    renderIcon(icon: string) {
        switch (icon) {
            case 'arrow-next-gallery-desktop':
                return (
                    <img
                        style={{
                            height: this.props.height
                                ? this.props.height
                                : '14px',
                            outline: 'none',
                        }}
                        src={arrow_next_gallery_slide_desktop.src}
                        alt="arrow-gallery-desktop"
                    />
                )
            case 'arrow-prev-gallery-desktop':
                return (
                    <img
                        style={{
                            height: this.props.height
                                ? this.props.height
                                : '14px',
                        }}
                        src={arrow_prev_gallery_slide_desktop.src}
                        alt="arrow-gallery-desktop"
                    />
                )

            case 'location':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : '20px',
                            height: this.props.width
                                ? this.props.width
                                : '20px',
                        }}
                        src={location.src}
                        alt="location-icon"
                    />
                )

            case 'location_white':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : '20px',
                        }}
                        src={location_white.src}
                        alt="location-icon"
                    />
                )

            case 'credits':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : '20px',
                            height: this.props.width
                                ? this.props.width
                                : '20px',
                        }}
                        src={credits_circle.src}
                        alt="credits-icon"
                    />
                )
            case 'blue-arrow-gallery-slide-mobile':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : 'auto',
                            height: this.props.width
                                ? this.props.width
                                : '20px',
                        }}
                        src={blue_arrow_gallery_slide_mobile.src}
                        alt="blue arrow gallery slide mobile"
                    />
                )

            case 'blue_arrow_previous':
                return (
                    <img
                        src={arrow_blue_previous.src}
                        alt="navigation-arrow-previous"
                    />
                )
            case 'car_listed':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : '20px',
                            height: this.props.width
                                ? this.props.width
                                : '20px',
                        }}
                        src={car_listed.src}
                        alt="car-listed-icon"
                    />
                )
            case 'arrow_white':
                return (
                    <img
                        style={{
                            width: this.props.width ? this.props.width : '20px',
                        }}
                        src={arrow_white.src}
                        alt="arrow-white"
                    />
                )

            default:
                return <div style={{ display: 'none' }} />
        }
    }
    render() {
        return this.renderIcon(this.props.icon)
    }
}

export default Icon
